export default __webpack_public_path__ + "static/media/ion_qubit.c7d8740e.jpeg";